import { Injectable, signal } from '@angular/core';
import { IDashboardResumo, IDashboardResumoRecepcao, IDashboardResumoProfissional } from '@nomoh-monorepo/shared-types';

@Injectable({ providedIn: 'root' })
export class DashboardDataService {
  private _resumo = signal<IDashboardResumo | null>(null);
  private _resumoRecepcao = signal<IDashboardResumoRecepcao | null>(null);
  private _resumoProfissional = signal<IDashboardResumoProfissional | null>(null);
  private _loading = signal(false);

  $resumo = this._resumo.asReadonly();
  $resumoRecepcao = this._resumoRecepcao.asReadonly();
  $resumoProfissional = this._resumoProfissional.asReadonly();
  $loading = this._loading.asReadonly();

  setResumo(resumo: IDashboardResumo) {
    this._resumo.set(resumo);
  }

  setResumoRecepcao(resumo: IDashboardResumoRecepcao) {
    this._resumoRecepcao.set(resumo);
  }

  setResumoProfissional(resumo: IDashboardResumoProfissional) {
    this._resumoProfissional.set(resumo);
  }

  setLoading(v: boolean) {
    this._loading.set(v);
  }
}
